import { render, staticRenderFns } from "./customStatisticalList.vue?vue&type=template&id=64442e98&"
import script from "./customStatisticalList.vue?vue&type=script&lang=js&"
export * from "./customStatisticalList.vue?vue&type=script&lang=js&"
import style0 from "./customStatisticalList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports